import { Pipe, PipeTransform } from '@angular/core';
import { Planning } from '../classes/planning.class';
import { UserId } from '../services/entities/entity-type.class';

@Pipe({
    name: 'performerOrHiringCompany',
})
export class PerformerOrHiringCompanyPipe implements PipeTransform {
    transform(plannings: Planning[] | Planning): string {
        if (!plannings) {
            return '';
        }
        plannings = Array.isArray(plannings) ? plannings : [plannings];
        const performer = plannings.find(p => !!p.performer && p.performer !== UserId.HiringPerformer);

        if (performer) {
            return plannings.find(p => !!p.performer_user)?.performer_user?.name;
        } else {
            const isHiring = plannings
                .map(p => p.planning_has.find(ph => ph.entitytype_key === 'hiringStaff'))
                .flat()
                .find(p => !!p);
            if (isHiring) {
                return isHiring.hiring?.name ?? isHiring.name;
            }
        }

        return '';
    }
}
